import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DASHBOARD_FEATURE_KEY, DashboardState } from './dashboard.reducer';
import { LatestUpdate } from '../latest-updates/latest-updates.model';

// Lookup the 'Dashboard' feature state managed by NgRx
const getDashboardState = createFeatureSelector<DashboardState>(
  DASHBOARD_FEATURE_KEY,
);

const getLatestUpdates = createSelector(getDashboardState, (state) =>
  state.latestUpdates
    .filter((u) => u.category === 'latestupdates' && u.subcategeory === '')
    .sort(
      (a: LatestUpdate, b: LatestUpdate): number =>
        new Date(b.date).getTime() - new Date(a.date).getTime(),
    ),
);

const getNewFeatures = createSelector(getDashboardState, (state) =>
  state.latestUpdates
    .filter(
      (u) => u.category === 'latestupdates' && u.subcategeory === 'newfeatures',
    )
    .sort(
      (a: LatestUpdate, b: LatestUpdate): number => a.priority - b.priority,
    ),
);

const getNewFeatureBanners = createSelector(getDashboardState, (state) =>
  state.latestUpdates
    .filter((u) => u.category === 'banner' && u.subcategeory === '')
    .sort(
      (a: LatestUpdate, b: LatestUpdate): number => a.priority - b.priority,
    ),
);

const getLatestUpdatesLoading = createSelector(
  getDashboardState,
  (state) => state.latestUpdatesLoading,
);

const getManageAccessUsers = createSelector(
  getDashboardState,
  (state) => state.manageAccessUsers,
);

const getManageAccessUsersLoading = createSelector(
  getDashboardState,
  (state) => state.manageAccessUsersLoading,
);

const getManageAccessViewingUser = createSelector(
  getDashboardState,
  (state) => state.manageAccessViewingUser,
);

const getManageAccessViewingUserView = createSelector(
  getDashboardState,
  (state) => state.manageAccessViewingUserView,
);

const getMessages = createSelector(
  getDashboardState,
  (state) => state.messages,
);

const getMessagesLoading = createSelector(
  getDashboardState,
  (state) => state.isMessagesLoading,
);

const getMessagesError = createSelector(
  getDashboardState,
  (state) => state.messagesError,
);

export const dashboardQuery = {
  getLatestUpdates,
  getNewFeatures,
  getNewFeatureBanners,
  getLatestUpdatesLoading,
  getManageAccessUsers,
  getManageAccessUsersLoading,
  getManageAccessViewingUser,
  getManageAccessViewingUserView,
  getMessages,
  getMessagesLoading,
  getMessagesError,
};
